import React from 'react';

import { cn } from '@app/shared/utils/common';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  className?: string;
};

export function Label({ children, className = '', ...props }: LabelProps) {
  return (
    <label className={cn('text-sm font-medium', className)} {...props}>
      {children}
    </label>
  );
}
